const artList = [
    {
        id: 1,
        title: "Vases",
        image: require("./artImages/art-1.webp"),
        className: "grid justify-center ",
        page: '/vases'

    },
    {
        id: 2,
        title: "Baskets",
        image: require("./artImages/art-8.webp"),
        className: "grid justify-center ",
        page: '/baskets'

    },
 
   
    {
        id: 3,
        title: "Bowls",
        image: require("./artImages/art-6.webp"),
        className: " grid justify-center",
        page: '/bowls'

    },
    {
        id: 4,
        title: "Tiles",
        image: require("./artImages/art-5.webp"),
        className: "grid justify-center ",
        page: '/dreamscapes'

    },
    {
        id: 5,
        title: "Sculptures",
        image: require("./artImages/sculpture-5.webp"),
        className: "grid justify-center ",
        page: '/sculptures'

    },
   

]

export default artList;